import { currentWindowMediaXsOnly } from 'cadenza/utils/media';

/**
 * For mobile views: (XsOnly) the user need as much space as possible to use the routing module
 * so we remove all the non-essential elements from the screen.
 * #Content element:
 *   -'contentNoHeader': Removes the header
 *   -'content-no-toolbar': Removes the toolbars
 * Map:
 *   -'minimal': Removes the map-controls
 *   -'vertical-split': uses the top split part of the screen instead of all the height
 *
 * @param {boolean} enable - If true, enables routing mobile layout, disables it otherwise
 * @param {ol.Map} map - The instance of the related map
 */
export function setRoutingMobileModeLayout (enable, map) {
  setRoutingMobileModeContentLayout(enable);
  setRoutingMobileModeMapLayout(enable, map);
}

const CONTENT_ELEMENT_CLASSES = [ 'contentNoHeader', 'content-no-toolbar' ];

/**
 *  There is a special layout for the routing running on Xs devices
 *  It adds some classes to the content element only for this size and removes them in any other
 *  case
 *
 * @param {boolean} enable - Indicates if the routing layout is enable or not
 */
function setRoutingMobileModeContentLayout (enable) {
  const contentNode = document.querySelector('#content');
  if (contentNode) { // no content node in workbooks
    updateClassesForMobile(enable, contentNode, CONTENT_ELEMENT_CLASSES);
  } else {
    const mapContainer = document.querySelector('.mapContainer');
    updateClassesForMobile(enable, mapContainer, CONTENT_ELEMENT_CLASSES);
  }
}

const MAP_CLASSES = [ 'minimal', 'vertical-split' ];

/**
 *  There is an especial layout for the routing running on Xs devices
 *  It adds some classes to the Map element only for this size and, removes them in any other case.
 *
 * @param {boolean} enable - Indicates if the routing layout is enable or not
 * @param {ol.Map} map - The instance of the related map
 */
export function setRoutingMobileModeMapLayout (enable, map) {
  const mapNode = map.getTarget();
  updateClassesForMobile(enable, mapNode, MAP_CLASSES);
  map.updateSize();
}

function updateClassesForMobile (enable, node, classes) {
  const activeAndMediaMatches = enable && currentWindowMediaXsOnly.matches;
  return activeAndMediaMatches
    ? node.classList.add(...classes)
    : node.classList.remove(...classes);
}
